import { WithdrawalReasons } from './WithdrawalReasons'

export default WithdrawalReasons
